import { EventEmitter, Inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';

//Menu Bar
export interface Menu {
  read?: boolean,
  roleRight?: string
  headTitle?: string,
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  status?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  url?: string;
  children?: Menu[];
}
@Injectable({
  providedIn: 'root'
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);
  public megaMenu: boolean = false;
  public megaMenuCollapse: boolean = window.innerWidth < 1199 ? true : false;
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;
  public isActiveMenu: boolean = true;
  public fullScreen: boolean = false;
  MENUITEMS: Menu[] = []  // menu list moved to side bar component
  // items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
  isSidebarVisible: boolean = false; // for Menu resize handle the title at sidebar based on the toggle
  sidebarVisibilityChange: Subject<boolean> = new Subject<boolean>();
  constructor(
    private router: Router, @Inject('edgeEndPoint') private edgeUrl: string
  ) {
    this.sidebarVisibilityChange.subscribe((value) => {
      this.isSidebarVisible = value;
    });
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize').pipe(
      // debounceTime(1000),
      takeUntil(this.unsubscriber)
    ).subscribe((evt: any) => {
      this.setScreenWidth(evt.target.innerWidth);
      if (evt.target.innerWidth < 991) {
        this.collapseSidebar = false;
        this.megaMenu = false;
      }
      if (evt.target.innerWidth < 1199) {
        this.megaMenuCollapse = true;
      }
    });
    if (window.innerWidth < 991) {
      this.router.events.subscribe(event => {
        this.collapseSidebar = false;
        this.megaMenu = false;
      });
    }
  }
  // for Menu resize handle the title at sidebar based on the toggle
  toggleSidebarVisibility(value) {
    this.sidebarVisibilityChange.next(value ? value : false);
  }
  ngOnDestroy() {
    this.unsubscriber.next({});
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }
}

// All side menu links are moved to side bar component 
